export default __webpack_public_path__ + "static/media/statementOfSuitability.9d3fd00b.jpeg";